import Fab from "@mui/material/Fab";
import { onContactUsClick } from "@utils/contactUs";
import { needHelpMessage } from "../../constants";
import { WhatsAppIcon } from "@icons/WhatsAppIcon";

interface WhatsAppSupportFabProps {
  position: "bottom-left" | "bottom-right";
}

const positionStyles = {
  "bottom-left": {
    bottom: "16px",
    left: "16px",
  },
  "bottom-right": {
    bottom: "16px",
    right: "16px",
  },
};

export const WhatsAppSupportFab = ({ position }: WhatsAppSupportFabProps) => {
  return (
    <Fab
      aria-label="support"
      onClick={() => onContactUsClick(needHelpMessage)}
      size="medium"
      sx={{
        position: "fixed",
        ...positionStyles[position],
      }}
    >
      <WhatsAppIcon />
    </Fab>
  );
};
